<template>
  <div class="builder-external-tracks">
    <v-card>
      <v-card-title>External tracks</v-card-title>
      <v-card-text>
        <BuilderMusicExternalTrack />
        <v-data-table
          :headers="headers"
          :items="externalTracks"
          :items-per-page="5"
          class="elevation-1"
          data-testid="external-tracks-table"
        >
          <template v-slot:item.image="{ item }">
            <img
              class="external_track__cover_image"
              :src="item.images[0].url"
              :width="40"
              :height="40"
            />
          </template>

          <template v-slot:item.actions="{ item, index }">
            <v-btn :href="item.preview_url" target="_blank" icon title="Audio">
              <v-icon>mdi-play</v-icon>
            </v-btn>

            <v-btn
              @click="deleteExternalTrack(index)"
              icon
              title="Delete"
              data-testid="external-track-delete"
            >
              <v-icon>mdi-delete</v-icon>
              </v-btn>
          </template>
        </v-data-table>

        </v-card-text>
    </v-card>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { ExternalTrack } from '@/types'
import BuilderMusicExternalTrack from './BuilderMusicExternalTrack.vue'

export default defineComponent({
  data () {
    return {
      headers: [
        { text: '', value: 'image', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Artist', value: 'artist_name' },
        { text: 'Album', value: 'album_name' },
        { text: 'Release date', value: 'release_date' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    }
  },

  components: {
    BuilderMusicExternalTrack,
  },
  // use the vuex getter
  computed: {
    externalTracks (): ExternalTrack[] {
      return this.$store.getters.campaignExternalTracks
    },
  },

  methods: {
    // use the vuex action
    deleteExternalTrack (idx: number) {
      console.log('DELETE', idx)
      this.$store.commit('REMOVE_CAMPAIGN_EXTERNAL_TRACK', idx)
    },

  },

})
</script>
<style scoped>
.external_track__cover_image {
    object-fit: cover;
}
</style>
